{
  "aboutSubProject": "Om delprosjektet",
  "clusterOperation": "Klyngedrift",
  "noActiveClusterOperation": "Det finnes ingen aktiv klyngedrift",
  "previousOperation": "Tidligere klyngedrift"
}
